var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(_vm.padding || _vm.border || _vm.color) ? _vm.getClasses() :''},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.icon),expression:"icon"}],staticClass:"icon-header",class:_vm.icon}),_c('span',{staticClass:"header-text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }